<template>
  <button @click="clicked" class="form-btn" :type="type" :disabled="isLoading || isDisabled" :class="{
    'btn-primary': color === 'primary',
    'btn-error': color === 'error',
    'btn-info': color === 'info',
    'btn-black': color === 'black',
    'btn-secondary': color === 'secondary',
    'btn-success': color === 'success',
  }">
    <div class="flex justify-center items-center gap-2">
      <svg v-if="isLoading" class="w-5 h-5 text-white animate-spin" fill="none" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <circle class="opacity-0" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          fill="currentColor"></path>
      </svg>
      <span v-else>
        {{ label }}
      </span>
    </div>
  </button>
</template>

<script>
export default {
  name: "hs-button",
  props: {
    type: { type: String, default: "submit" },
    color: { type: String, default: "primary" },
    label: { type: String, default: "submit" },
    isLoading: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  methods: {
    clicked() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  &-btn {
    @apply w-full h-[46px] px-4 rounded-2xl uppercase disabled:cursor-not-allowed;
    color: #fff;
    font-size: 0.82rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    transition: transform 0.22s ease, box-shadow 0.22s ease, opacity 0.22s ease;
    box-shadow: var(--hs-shadow-soft);

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
    }
  }
}

.btn-primary {
  background: linear-gradient(135deg, var(--hs-primary), var(--hs-primary-strong));
}

.btn-error {
  background: linear-gradient(135deg, #ef4444, #b91c1c);
}

.btn-success {
  background: linear-gradient(135deg, #16a34a, #15803d);
}

.btn-info {
  background: linear-gradient(135deg, #0284c7, #0369a1);
}

.btn-secondary {
  color: var(--hs-text);
  border: 1px solid var(--hs-border);
  background: color-mix(in srgb, var(--hs-surface) 90%, transparent);
}

.btn-black {
  background: linear-gradient(135deg, #0f172a, #020617);
}
</style>
